<template>
  <nuxt-link v-if="category.slug" class="link" :to="`/${category.slug}/`">
    <div class="text">
      {{ category.name }}
    </div>
    <div v-if="category.image && isImage" class="img">
      <ui-responsive-image
        :src="category.image"
        :alt="category.name"
        :lazy="true"
        draggable="false"
        :mobile-sizes="{ width: 32, height: 32 }"
        :desktop-sizes="{ width: 48, height: 48 }"
      />
    </div>
    <debug-info
      v-if="debugPanel"
      class="debug-category-item"
      :data="category"
    />
  </nuxt-link>
</template>

<script lang="ts" setup>
import type { ModelCategory } from '~/interfaces/api';
import { useGlobalStore } from '~/stores/global';
const globalStore = useGlobalStore();
const debugPanel = computed(() => globalStore.debugPanel);
defineProps({
  category: {
    type: Object as () => ModelCategory,
    required: true,
  },
  isImage: {
    type: Boolean,
    default: true,
  },
});
</script>
<style scoped lang="scss" src="./category-item.scss"></style>
